import React from 'react';
import { Helmet } from 'react-helmet';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var MetaPage = function MetaPage(_ref) {
  var title = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords;
  return /*#__PURE__*/_jsxs(Helmet, {
    defaultTitle: "Amur",
    children: [title && /*#__PURE__*/_jsxs("title", {
      children: ["Amur", title && ": ".concat(title)]
    }), description && /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: description
    }), keywords && /*#__PURE__*/_jsx("meta", {
      name: "keywords",
      content: keywords
    })]
  });
};

export { MetaPage };